import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';


const getPhonebyNum = (number: any) => {
    return AxiosInstance.get(`${Config.API_URL}/api/PhoneStatistics/${number}`);
};

const getUserStatbyId = (id: any) => {
    return AxiosInstance.get(`${Config.API_URL}/api/PhoneStatistics/user/${id}`);
}

const getStatisticsByPhoneId = (id: any) => {
    return AxiosInstance.get(`${Config.API_URL}/api/PhoneStatistics/NewSubscription/${id}`);
};

export const PhoneStatisticsService = {
    getPhonebyNum,
    getUserStatbyId,
    getStatisticsByPhoneId
};

